<template>
    <BaseButton
        :tooltip="localizations[lang].tooltips.tableOfContents"
        :class="[ui.audiobook.playlist.opened ? 'header-btn-active' : 'text-theme-icon']"
        dusk="buttonAudiobookPlaylist"
        icon="baseline-view_list-24px"
        :aria-expanded="String(ui.audiobook.playlist.opened)"
        @click="toogleAudiobookPlaylist"
    />
</template>
<script>
import BaseButton from './BaseButton.vue';
import { mapMutations, mapState } from 'vuex';

export default {
    components: {
        BaseButton,
    },
    computed: {
        ...mapState(['localizations', 'lang', 'ui']),
    },
    methods: {
        ...mapMutations(['toogleAudiobookPlaylist']),
    },
};
</script>
